<script>
  import { onMount } from "svelte";

  export let title;
  export let value;
  export let options = [];
  export let error;
  export let defaultValue = options[0].value;
  export let isHorizontal = false;

  onMount(() => {
    value = value || defaultValue;
  });
</script>

<div class="field" class:is-horizontal={isHorizontal}>
  <div class:field-label={isHorizontal} class="is-small">
    <label class="label is-small">{title}</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control is-small">
        <select
          class="select"
          bind:value
          on:change={e => (value = e.target.value)}>
          {#each options as option}
            <option value={option.value}>{option.label}</option>
          {/each}
        </select>
        {#if error}
          <p class="help is-danger">{error}</p>
        {/if}
      </div>
    </div>
  </div>
</div>
